module.exports = __webpack_public_path__ + "static/img/photo08.fce2687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hakodate/photo08.jpg
// module id = KnOm
// module chunks = 0